import { App } from './App';

class CsvDownloader {
    settings = {
        fetchFn: null,
        windowRef: null,
        documentRef: null,
        defaultFileName: 'export_data.csv'
    };

    constructor(csvDownloaderSettings) {
        this.settings = { ...this.settings, ...csvDownloaderSettings };
        this.windowRef = this.settings.windowRef || window;
        this.documentRef = this.settings.documentRef || document;
        this.fetchFn = this.settings.fetchFn || this.windowRef.fetch.bind(this.windowRef);
    }

    async download(action, formElement, method) {
        if (!formElement) {
            return;
        }

        const formData = new FormData(formElement);
        const response = await this.fetchFn(action, {
            method: method || 'POST',
            body: formData
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const fileName = this.settings.defaultFileName;
        if (typeof this.windowRef.showSaveFilePicker === 'function' && response.body) {
            const handle = await this.windowRef.showSaveFilePicker({
                suggestedName: fileName,
                types: [{
                    description: 'CSV Files',
                    accept: { 'text/csv': ['.csv'] }
                }]
            });

            const writable = await handle.createWritable();
            await response.body.pipeTo(writable);
            return;
        }

        const blob = await response.blob();
        const objectUrl = this.windowRef.URL.createObjectURL(blob);
        const link = this.documentRef.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        this.documentRef.body.appendChild(link);
        link.click();
        this.documentRef.body.removeChild(link);
        this.windowRef.URL.revokeObjectURL(objectUrl);
    }
}

App.CsvDownloaderClass = CsvDownloader;
export default CsvDownloader;
